import { useTranslation } from 'react-i18next'
import { CampaignCreateParams, Provider } from '../../../types'
import { UseFormReturn, useWatch } from 'react-hook-form'
import { useEffect, useMemo } from 'react'
import { SingleSelect } from '../../../ui/form/SingleSelect'

interface ProviderSelectionParams {
    providers: Provider[]
    form: UseFormReturn<CampaignCreateParams>
}

export default function CampaignProviderSelection({ providers, form }: ProviderSelectionParams) {
    const { t } = useTranslation()
    const channel = useWatch({
        control: form.control,
        name: 'channel',
    })
    providers = useMemo(() => channel ? providers.filter(p => p.group === channel || (channel === 'in_app' && p.group === 'push')) : [], [channel, providers])
    useEffect(() => {
        if (channel && providers.length) {
            const { provider_id } = form.getValues()
            if (!provider_id || !providers.find(p => p.id === provider_id)) {
                form.setValue('provider_id', providers[0].id)
            }
        }
    }, [channel, form, providers])
    return (
        <SingleSelect.Field
            form={form}
            name="provider_id"
            label={t('provider')}
            options={providers}
            required
            toValue={x => x.id}
        />
    )
}
